import axios from 'axios';
import { BASE_URL } from '@/config/const';
// import { convertZuluTime } from '@/util';

class LiveTalkAPI {
  async get(livetalkId) {
    return await axios.get(`${BASE_URL}/v2/livetalk/livetalk/${livetalkId}/detail`);
  }
}

export default new LiveTalkAPI();


